{
  "accountInformationText": "नीचे अपने व्यक्तिगत खाते का विवरण अपडेट करें।",
  "accountSettings": "खाता सेटिंग्स",
  "accountStatus": "अकाउंट स्थिति",
  "accountStatusText": "आपका खाता वर्तमान में अच्छी स्थिति में है।",
  "active": "सक्रिय",
  "administrator": "प्रशासक",
  "backupCodeFailed": "बैकअप कोड सत्यापन विफल रहा।",
  "backupCodes": "बैकअप कोड",
  "backupCodesWarning": "ये कोड केवल एक बार दिखाए जाएँगे। इन्हें सुरक्षित रखें। प्रत्येक कोड केवल एक बार उपयोग किया जा सकता है।",
  "changePassword": "पासवर्ड बदलें",
  "confirmPassword": "पासवर्ड की पुष्टि करें",
  "copyBackupCodes": "बैकअप कोड कॉपी करें",
  "currentPassword": "वर्तमान पासवर्ड",
  "darkMode": "डार्क मोड",
  "depositWithdrawalAlerts": "डिपॉज़िट और निकासी अलर्ट",
  "disable2FA": "2FA अक्षम करें",
  "disable2fa": "Google Authenticator अक्षम करें",
  "downloadBackupCodes": "बैकअप कोड डाउनलोड करें",
  "emailNotifications": "ईमेल सूचनाएं",
  "enterAuthenticatorCode": "अपने ऑथेंटिकेटर ऐप से 6 अंकों का कोड दर्ज करें",
  "enterAuthenticatorCodeFirst": "कृपया पहले ऑथेंटिकेटर कोड दर्ज करें।",
  "enterSixDigitCode": "6 अंकों का कोड दर्ज करें",
  "goToKycVerification": "KYC सत्यापन पर जाएं",
  "googleAuthenticator2fa": "Google Authenticator (2FA)",
  "googleAuthenticator2faText": "Google Authenticator का उपयोग करके अपने खाते में सुरक्षा की एक अतिरिक्त परत जोड़ें।",
  "googleAuthenticatorDisabled": "Google Authenticator अक्षम कर दिया गया है।",
  "googleAuthenticatorEnabled": "Google Authenticator सक्षम कर दिया गया है।",
  "inactive": "निष्क्रिय",
  "invalidCode": "कोड अमान्य है। कृपया पुनः प्रयास करें।",
  "invalidVerificationCode": "सत्यापन कोड अमान्य है।",
  "kycStatusText": "पूर्ण खाता सुविधाएं अनलॉक करने के लिए पहचान सत्यापन पूरा करें।",
  "language": "भाषा",
  "languagePreferencesText": "अपने खाते में उपयोग होने वाली भाषा चुनें।",
  "languageSettings": "भाषा सेटिंग्स",
  "lightMode": "लाइट मोड",
  "loading": "लोड हो रहा है...",
  "loginAlerts": "लॉगिन अलर्ट",
  "manualSetupKey": "मैनुअल सेटअप कुंजी",
  "newBackupCodesGenerated": "नए बैकअप कोड जनरेट हो गए। इन्हें सुरक्षित स्थान पर सहेजें।",
  "newPassword": "नया पासवर्ड",
  "notificationPreferences": "सूचना प्राथमिकताएं",
  "notificationPreferencesText": "चुनें कि आप कौन-सी सूचनाएं प्राप्त करना चाहते हैं।",
  "notificationSettings": "सूचना सेटिंग्स",
  "owner": "स्वामी",
  "ownerControlCenter": "स्वामी नियंत्रण केंद्र",
  "ownerDisableBlocked": "स्वामी खाता Google Authenticator को अक्षम नहीं कर सकता।",
  "p2pAlerts": "P2P अलर्ट",
  "p2pOrderAlerts": "P2P ऑर्डर अलर्ट",
  "pushNotifications": "पुश सूचनाएं",
  "regenerateBackupCodes": "नए बैकअप कोड बनाएँ",
  "require2FASetup": "जारी रखने से पहले Google Authenticator सेटअप आवश्यक है।",
  "role": "भूमिका",
  "saveBackupCodes": "बैकअप कोड सहेजें",
  "saveChanges": "परिवर्तन सहेजें",
  "saving": "सहेजा जा रहा है...",
  "scanQrCode": "यह QR कोड स्कैन करें",
  "scanQrCodeAuthenticator": "अपने ऑथेंटिकेटर ऐप से यह QR कोड स्कैन करें",
  "securityAlerts": "सुरक्षा अलर्ट",
  "securityRules": "सुरक्षा नियम",
  "securitySettings": "सुरक्षा सेटिंग्स",
  "selectLanguage": "भाषा चुनें",
  "serverError": "सर्वर त्रुटि।",
  "sessionExpired": "सत्र समाप्त हो गया है। कृपया पुनः लॉगिन करें।",
  "settingRuleBotProtection": "इस खाते पर स्वचालित बॉट गतिविधि सुरक्षा सक्रिय है।",
  "settingRuleDepositReview": "आपके बैलेंस में जमा होने से पहले बड़ी जमा राशियों की समीक्षा की जाती है।",
  "settingRuleKyc": "निकासी स्वीकृत होने से पहले पहचान सत्यापन आवश्यक है।",
  "settingRuleManualReview": "संदिग्ध गतिविधि मैन्युअल सुरक्षा समीक्षा को ट्रिगर कर सकती है।",
  "settingRuleWalletMatch": "निकासी एक सत्यापित वॉलेट पते से मेल खानी चाहिए।",
  "settingsSubtitle": "अपने खाते, भाषा, प्रमाणीकरण और सुरक्षा का प्रबंधन करें।",
  "settingsTitle": "सेटिंग्स और सुरक्षा",
  "settingsUpdateFailed": "सेटिंग्स अपडेट करने में विफल।",
  "settingsUpdated": "सेटिंग्स सफलतापूर्वक अपडेट की गईं।",
  "setup2FA": "Google Authenticator सेट अप करें",
  "setupGoogleAuthenticator": "Google Authenticator सेट अप करें",
  "systemDefault": "सिस्टम डिफ़ॉल्ट",
  "theme": "थीम",
  "twoFaSetupFailed": "दो-चरणीय सत्यापन सेटअप विफल रहा।",
  "twoFactorAuthentication": "Google Authenticator (2FA)",
  "twoFactorDescription": "Google Authenticator का उपयोग करके अपने खाते को सुरक्षित करें।",
  "twoFactorDisabled": "दो-चरणीय सत्यापन अक्षम हो गया",
  "twoFactorDisabledSuccess": "Google Authenticator सफलतापूर्वक अक्षम किया गया।",
  "twoFactorEnabled": "दो-चरणीय सत्यापन सक्षम हो गया",
  "twoFactorSecurity": "दो-चरणीय सुरक्षा",
  "twoFactorSecurityText": "मजबूत खाता सुरक्षा के लिए दो-चरणीय सत्यापन सक्षम करें।",
  "twoFactorSetupFailed": "2FA सेटअप विफल रहा।",
  "twoFactorVerified": "Google Authenticator सफलतापूर्वक सक्षम किया गया।",
  "user": "User",
  "verificationCode": "सत्यापन कोड",
  "verify2FA": "सत्यापित करें और सक्षम करें",
  "verifyAndEnable": "सत्यापित करें और सक्षम करें"
}